var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.26465 8.8133C1.39649 5.73147 3.93667 3.27344 7.05095 3.27344L17.1234 3.27344C20.2377 3.27344 22.7779 5.73147 22.9097 8.8133H1.26465Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9151 10.3242V15.1086C22.9151 18.3073 20.3221 20.9003 17.1234 20.9003H7.05095C3.8523 20.9003 1.25928 18.3073 1.25928 15.1086V10.3242H22.9151ZM6.04371 14.8568C5.62649 14.8568 5.28827 15.195 5.28827 15.6122C5.28827 16.0294 5.62649 16.3677 6.04371 16.3677H11.0799C11.4972 16.3677 11.8354 16.0294 11.8354 15.6122C11.8354 15.195 11.4972 14.8568 11.0799 14.8568H6.04371Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardsActive);
export default __webpack_public_path__ + "static/media/cards-active.6e3dfce9e3ba9db4dc248f32bf584f23.svg";
export { ForwardRef as ReactComponent };